const key = (sccoId, date) => `sa_hidden_${sccoId}_${date}`;

export function loadHiddenIds(sccoId, date) {
  try { return new Set(JSON.parse(localStorage.getItem(key(sccoId, date)) || "[]")); }
  catch { return new Set(); }
}

export function saveHiddenIds(sccoId, date, ids) {
  localStorage.setItem(key(sccoId, date), JSON.stringify([...ids]));
}
